



















import {Vue, Component, PropSync} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';

@Component({
  components: {
    CompSelectBox
  }
})
export default class PlatformTypeCheckList extends Vue{
  private platformTypeCheckList = ['PC', 'MOBILE_WEB', 'MOBILE_APP']
  private isPlatformTypeCheckedAll = true

  @PropSync('platformTypes')
  private platformTypesSync!: string[]

  private isAllChecked(): void{
    this.$nextTick(()=>{
      if(this.platformTypesSync.length === this.platformTypeCheckList.length){
        this.isPlatformTypeCheckedAll = true
        return
      }

      this.isPlatformTypeCheckedAll = false
    })
  }

  private checkAll(): void{
    this.isPlatformTypeCheckedAll = !this.isPlatformTypeCheckedAll
    if(this.isPlatformTypeCheckedAll){
      this.platformTypesSync = [...this.platformTypeCheckList]
      return
    }

    this.platformTypesSync = []
  }

  public reset(){
    this.isPlatformTypeCheckedAll = false;
    this.checkAll();
  }

  private created(){
    this.reset()
  }

}
